var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.23684 8.32294L0.0001688 7.08511L6.74 0.342942C6.848 0.234262 6.97642 0.148012 7.11788 0.0891558C7.25934 0.0302999 7.41104 0 7.56425 0C7.71747 0 7.86917 0.0302999 8.01063 0.0891558C8.15208 0.148012 8.28051 0.234262 8.3885 0.342942L15.1318 7.08511L13.8952 8.32178L7.566 1.99378L1.23684 8.32294Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.623065b137e35369259c405df5c76ed4.svg";
export { ForwardRef as ReactComponent };